<template>
  <span
    v-if="model.knockouts?.length"
    v-tooltip="model.knockouts ? allKnockoutReasons : null"
    data-cy="scorecard-group-knockout-icon"
  >
    <icon-base :icon="IconKnockout" :color="UTIL_COLORS.WARNING" />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { UTIL_COLORS } from "@/helpers/constants";
import {
  expandContentCategory,
  formatKnockoutReasons,
} from "@/helpers/scorecards";

import IconKnockout from "@/components/icons/IconKnockout.vue";

import type { ScorecardForGroupTable } from "@/models/scorecards";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ScorecardForGroupTable>,
    required: true,
  },
});

const { getters } = useStore();

const activeServices = computed(() => getters["scorecards/activeServices"]);

const knockoutsWithExpandedCategories = computed(() => {
  const knockouts = props.model.knockouts?.map((knockout, index) => {
    const category = expandContentCategory(
      knockout.category,
      index,
      activeServices.value
    );
    return {
      ...knockout,
      category,
    };
  });
  return {
    ...props.model,
    knockouts,
  };
});

const allKnockoutReasons = computed(() => {
  const reasons = knockoutsWithExpandedCategories.value.knockouts?.map(
    (knockout) => {
      if (!knockout.category) {
        return "";
      }
      return formatKnockoutReasons(
        knockout.category.name,
        knockout.category.knockout_conditions
      );
    }
  );
  return reasons.join(" ");
});
</script>
